var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Column, Entity, Index, ManyToOne, OneToMany } from 'typeorm';
import { Domain } from './domain.js';
import { BaseSnapshot } from './snapshot.js';
import { DNSAnalysis } from './analysis.js';
let DNSSnapshot = class DNSSnapshot extends BaseSnapshot {
    domain;
    records;
    analyses;
};
__decorate([
    ManyToOne(() => Domain, { nullable: true, onDelete: 'CASCADE' }),
    __metadata("design:type", Domain)
], DNSSnapshot.prototype, "domain", void 0);
__decorate([
    Column('jsonb'),
    __metadata("design:type", Array)
], DNSSnapshot.prototype, "records", void 0);
__decorate([
    OneToMany(() => DNSAnalysis, (a) => a.snapshot),
    __metadata("design:type", Array)
], DNSSnapshot.prototype, "analyses", void 0);
DNSSnapshot = __decorate([
    Entity({ name: 'dns_snapshots' }),
    Index('idx_dns_domain_created', ['domain', 'createdDate']),
    Index('idx_dns_project_created', ['project', 'createdDate'])
], DNSSnapshot);
export { DNSSnapshot };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic25hcHNob3QtZG5zLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2RvbWFpbi9tb2RlbHMvc25hcHNob3QtZG5zLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUFBLE9BQU8sRUFBRSxNQUFNLEVBQUUsTUFBTSxFQUFFLEtBQUssRUFBRSxTQUFTLEVBQUUsU0FBUyxFQUFFLE1BQU0sU0FBUyxDQUFDO0FBRXRFLE9BQU8sRUFBRSxNQUFNLEVBQUUsTUFBTSxhQUFhLENBQUM7QUFDckMsT0FBTyxFQUFFLFlBQVksRUFBRSxNQUFNLGVBQWUsQ0FBQztBQUM3QyxPQUFPLEVBQUUsV0FBVyxFQUFFLE1BQU0sZUFBZSxDQUFDO0FBS3JDLElBQU0sV0FBVyxHQUFqQixNQUFNLFdBQVksU0FBUSxZQUFZO0lBRTNDLE1BQU0sQ0FBVTtJQUdoQixPQUFPLENBQWU7SUFHdEIsUUFBUSxDQUFpQjtDQUMxQixDQUFBO0FBUEM7SUFEQyxTQUFTLENBQUMsR0FBRyxFQUFFLENBQUMsTUFBTSxFQUFFLEVBQUUsUUFBUSxFQUFFLElBQUksRUFBRSxRQUFRLEVBQUUsU0FBUyxFQUFFLENBQUM7OEJBQ3hELE1BQU07MkNBQUM7QUFHaEI7SUFEQyxNQUFNLENBQUMsT0FBTyxDQUFDOzs0Q0FDTTtBQUd0QjtJQURDLFNBQVMsQ0FBQyxHQUFHLEVBQUUsQ0FBQyxXQUFXLEVBQUUsQ0FBQyxDQUFDLEVBQUUsRUFBRSxDQUFDLENBQUMsQ0FBQyxRQUFRLENBQUM7OzZDQUN2QjtBQVJkLFdBQVc7SUFIdkIsTUFBTSxDQUFDLEVBQUUsSUFBSSxFQUFFLGVBQWUsRUFBRSxDQUFDO0lBQ2pDLEtBQUssQ0FBQyx3QkFBd0IsRUFBRSxDQUFDLFFBQVEsRUFBRSxhQUFhLENBQUMsQ0FBQztJQUMxRCxLQUFLLENBQUMseUJBQXlCLEVBQUUsQ0FBQyxTQUFTLEVBQUUsYUFBYSxDQUFDLENBQUM7R0FDaEQsV0FBVyxDQVN2QiJ9